import React from 'react';
import {
  WithStyles,
  createStyles,
  withStyles,
  Theme,
} from '@lifeomic/chroma-react/styles';
import clsx from 'clsx';
import { ButtonUnstyled } from '@lifeomic/chroma-react/components/ButtonUnstyled';
import { alpha } from '@mui/material';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      borderRadius: 2,
      cursor: 'pointer',
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.caption.fontSize,
      padding: theme.spacing(0.25, 0.75),
      '&$unselected': {
        '&:hover, &:focus': {
          background: alpha(theme.palette.common.black, 0.1),
        },
      },
    },
    unselected: {
      color: theme.palette.primary.main,
      transition: '0.25s',
      '&:hover, &:focus': {
        background: theme.palette.graphite[50],
        transition: '0.25s',
      },
    },
    selected: {
      background: theme.palette.primary.main,
      color: theme.palette.common.white,
      transition: '0.25s',
    },
    white: {
      color: theme.palette.common.white,
      transform: 'translate3d(0, 0, 0)', // GPU acceleration on transition
      '&$unselected': {
        '&:hover, &:focus': {
          background: alpha(theme.palette.primary[900], 0.35),
        },
      },
      '&$selected': {
        background: theme.palette.primary[900],
      },
    },
  });

export interface ControlButtonOwnProps {
  disabled: boolean;
  onToggle: (style: string) => void;
  style: string;
  active: boolean;
  label: string;
  whiteTheme?: boolean;
  className?: string;
}

export type ControlButtonProps = ControlButtonOwnProps &
  WithStyles<typeof styles>;

class ControlButton extends React.PureComponent<ControlButtonProps> {
  onToggle = (e: any) => {
    e.preventDefault();

    if (!this.props.disabled) this.props.onToggle(this.props.style);
  };

  render() {
    const {
      classes,
      className,
      active,
      label,
      whiteTheme = false,
    } = this.props;

    const textClassNames = active
      ? clsx(
          classes.root,
          classes.selected,
          !!whiteTheme && classes.white,
          className,
        )
      : clsx(
          classes.root,
          classes.unselected,
          !!whiteTheme && classes.white,
          className,
        );

    return (
      <ButtonUnstyled className={textClassNames} onClick={this.onToggle}>
        {label}
      </ButtonUnstyled>
    );
  }
}

export default withStyles(styles)(ControlButton);
